<div class="display-field-title {{titleClass}}">
  <div class="display-field-title__title">
    <div class="display-field-title__text">
      <span>{{field.title}}</span></div>
    <!--<hr>-->
  </div>
</div>
